import { render, staticRenderFns } from "./InstrumentsPercussion.vue?vue&type=template&id=1c574220"
import script from "./InstrumentsPercussion.vue?vue&type=script&lang=js"
export * from "./InstrumentsPercussion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports